import { Component, Input, output } from  "@angular/core";

@Component({
  selector: 'app-spacing-input',
  templateUrl: 'spacing-input.component.html',
  styleUrl: 'spacing-input.component.css'
})


export class SpacingInput {

  @Input() left = false;
  @Input() right = false; 
  @Input() top = false;
  @Input() bottom = false;
  @Input() value = 0;
  valueChange = output<number>() 


  handleChange(event:  Event) {
    const input = event.target as HTMLInputElement;
    const numberValue = parseInt(input.value)
    const isNumber = !isNaN(numberValue);

   if(isNumber){
    this.valueChange.emit(numberValue);
   }
     
  }
}